import { render, staticRenderFns } from "./SaveRecord.vue?vue&type=template&id=680d64be&"
import script from "./SaveRecord.vue?vue&type=script&lang=js&"
export * from "./SaveRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaveRecord.vue"
export default component.exports